import {
  RAW_APPROVAL_FAILED,
  RAW_APPROVAL_REQUEST,
  RAW_APPROVAL_SUCCESS,
} from "app/redux/actions/Order/RawApprovalOrder/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const rawApprovalReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case RAW_APPROVAL_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case RAW_APPROVAL_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case RAW_APPROVAL_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
